var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedcrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5419_7575)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.19727,
    y: 1.57617,
    width: 16.0919,
    height: 16.0919,
    rx: 1.78799,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6615 9.67548C15.6615 12.6379 13.26 15.0394 10.2976 15.0394C7.33512 15.0394 4.93359 12.6379 4.93359 9.67548C4.93359 6.71305 7.33512 4.31152 10.2976 4.31152C13.26 4.31152 15.6615 6.71305 15.6615 9.67548Z",
    fill: "#FD5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0064 7.96378C12.1489 8.10435 12.1505 8.33382 12.0099 8.47632L9.08593 11.4406C9.08416 11.4424 9.08236 11.4442 9.08053 11.4461L9.07592 11.4507C8.93479 11.592 8.70592 11.5925 8.56415 11.4518C8.42239 11.3111 8.42118 11.0823 8.56144 10.9401L11.4938 7.96729C11.6344 7.82478 11.8639 7.82322 12.0064 7.96378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60304 7.92642C8.74863 7.78907 8.97801 7.79575 9.11537 7.94135L11.9726 10.97C11.9744 10.9718 11.9761 10.9737 11.9779 10.9756L11.9823 10.9803C12.1185 11.1265 12.1108 11.3552 11.9651 11.4918C11.8194 11.6284 11.5906 11.6214 11.4536 11.4761L8.58811 8.43876C8.45076 8.29316 8.45744 8.06378 8.60304 7.92642Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5419_7575",
    x: 0.856276,
    y: 0.682179,
    width: 18.7738,
    height: 18.7738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.446996
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.670495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5419_7575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5419_7575",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedcrossIcon);
export default __webpack_public_path__ + "static/media/redcrossIcon.e83a95c715931e8db0dc69303d75e1d3.svg";
export { ForwardRef as ReactComponent };